import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import SortObject from "../../../types/SortObject";
import { DictionariesCurrencyModel } from "../../../viewModels/Dictionaries/DictionariesCurrencyModel";

const initialState: {
  loading: boolean;
  loadingData: boolean;
  currencies: Array<DictionariesCurrencyModel>;

  total: number;
  pageSize: number;
  page: number;
  sort: SortObject;
} = {
  loading: true,
  loadingData: true,

  currencies: undefined!,

  total: undefined!,
  pageSize: 10,
  page: 1,

  sort: {
    key: "date",
    order: "descend",
  },
};

const dictionariesCurrenciesSlice = createSlice({
  name: "dictionariesCurrencies",
  initialState,
  reducers: {
    loadCurrencies(state) {
      state.loadingData = true;
      state.page = 1;
    },
    loadCurrenciesSuccess(state, action: PayloadAction<{ currencies: Array<DictionariesCurrencyModel>; total: number }>) {
      const { currencies, total } = action.payload;
      state.loading = false;
      state.loadingData = false;
      state.currencies = currencies;
      state.total = total;
    },
    loadCurrenciesError(state) {
      state.loading = false;
      state.loadingData = false;
    },
    changeTable(state, action: PayloadAction<{ page: number; pageSize: number; sort: SortObject }>) {
      state.page = action.payload.page;
      state.pageSize = action.payload.pageSize;
      state.sort = action.payload.sort;
      state.loadingData = true;
    },
  },
});

export default dictionariesCurrenciesSlice;
